import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SectorsComponent } from './sectors/sectors.component';
import { SectorsCreateComponent } from './sectors-create/sectors-create.component';
import { SectorsEditComponent } from './sectors-edit/sectors-edit.component';

import { SECTORS_PATHS } from './sectors';

import { AuthGuard } from '../auth/auth.guard.service';
import { MonitoringComponent } from './monitoring/monitoring.component';

const routes: Routes = [
  {
    path: SECTORS_PATHS.sectors,
    component: SectorsComponent,
    canActivate: [AuthGuard],
    data: { animation: 'PlotsPage', permission: 'sector.get' },
  },
  {
    path: SECTORS_PATHS.sectors_create,
    component: SectorsCreateComponent,
    canActivate: [AuthGuard],
    data: { animation: 'PlotsCreatePage', permission: 'sector.add' },
  },
  {
    path: SECTORS_PATHS.monitoring,
    component: MonitoringComponent,
    canActivate: [AuthGuard],
    data: {
      animation: 'PlotsMonitoringPage',
      permission: 'sector.monitoring.get',
    },
  },
  {
    path: SECTORS_PATHS.sectors_edit,
    component: SectorsEditComponent,
    canActivate: [AuthGuard],
    data: { animation: 'PlotsEditPage', permission: 'sector.edit' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SectorsRoutingModule {}
